export default __webpack_public_path__ + "static/media/CVX.ba70ca8f.png";